import { lightVariablesArr, sizeVariablesArr } from '../Sonar.variables';

const SonarLightTheme = {
  metadata: {
    id: 'sonar-light',
    name: { enUS: 'Sonar Light', ptBR: 'Sonar Light', esES: 'Sonar Light' },
    isDark: false,
  },
  colors: lightVariablesArr,
  sizes: sizeVariablesArr,
};

export { SonarLightTheme };
